import React from "react";
import { useNavigate } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { STATUS_STYLE, statusLabel } from "@/lib/format";
import { cn } from "@/lib/utils";

export const StatusBadge = ({ status }) => (
  <Badge variant="outline" className={cn("font-medium capitalize", STATUS_STYLE[status] || "bg-slate-100 text-slate-600 border-slate-200")}>
    {statusLabel(status)}
  </Badge>
);

export const PageHeader = ({ title, subtitle, children, testid }) => (
  <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6" data-testid={testid}>
    <div>
      <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">{title}</h1>
      {subtitle && <p className="text-slate-500 text-sm mt-1">{subtitle}</p>}
    </div>
    {children && <div className="flex items-center gap-2 flex-wrap">{children}</div>}
  </div>
);

export const EmptyState = ({ icon: Icon, title, hint, action }) => (
  <div className="border-2 border-dashed border-slate-300 rounded-lg bg-slate-50 py-16 text-center">
    {Icon && <Icon className="w-10 h-10 mx-auto text-slate-400 mb-3" />}
    <p className="font-heading text-lg font-semibold text-slate-700">{title}</p>
    {hint && <p className="text-sm text-slate-500 mt-1">{hint}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export const Field = ({ label, children }) => (
  <div className="space-y-1.5">
    <label className="text-xs font-semibold tracking-[0.05em] uppercase text-slate-500">{label}</label>
    {children}
  </div>
);

export const Stat = ({ label, value, hint, tone = "default", icon: Icon, testid, to }) => {
  const nav = useNavigate();
  const tones = {
    default: "text-slate-900", danger: "text-rose-600", success: "text-emerald-600", warning: "text-amber-600", brand: "text-indigo-600",
  };
  return (
    <div className={cn("bg-white border border-slate-200 rounded-lg p-5 shadow-sm transition-all duration-200", to ? "hover:shadow-md hover:border-indigo-300 hover:-translate-y-0.5 cursor-pointer" : "hover:shadow-md")}
      data-testid={testid} onClick={to ? () => nav(to) : undefined} title={to ? "Open module" : undefined}>
      <div className="flex items-center justify-between">
        <span className="text-xs font-semibold tracking-[0.05em] uppercase text-slate-500">{label}</span>
        {Icon && <Icon className="w-4 h-4 text-slate-400" />}
      </div>
      <div className={cn("font-heading font-bold tracking-tight mt-2 text-2xl sm:text-3xl", tones[tone])}>{value}</div>
      {hint && <p className="text-xs text-slate-400 mt-1">{hint}</p>}
    </div>
  );
};
